require("./o-dossier-heading.scss");

var $ = require("jquery");

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    $('.o-dossier-heading__bg').each(function () {
        var $element = $(this);
        $element.css({
            width: (100 + scroll / 8) + "%"
        });
    });
});


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-dossier-heading/o-dossier-heading.chunk.js